exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: table-header-group;\n  background-color: #EFF0F4;\n  font-weight: 600; }\n  :host ::ng-deep tog-table-header-cell {\n    border-top: 1px solid #BABBC7 !important;\n    border-bottom: 1px solid #BABBC7 !important;\n    font-size: 12px;\n    font-weight: 300;\n    color: #5B6779;\n    padding: 5px 15px 3px 15px; }\n    :host ::ng-deep tog-table-header-cell:first-of-type {\n      border-left: 1px solid #BABBC7;\n      border-radius: 3px 0 0 0; }\n    :host ::ng-deep tog-table-header-cell:last-of-type {\n      border-right: 1px solid #BABBC7;\n      border-radius: 0 3px 0 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/table-header/table-header.component.scss
// module id = ../../../../../src/app/shared/components/table-header/table-header.component.scss
// module chunks = 12